/*
  L'affido, la pagina: toglie un corpo senza ricaricare. La sezione si
  ridisegna dal server e il conteggio nella testa si aggiorna; se la
  richiesta non riesce, il collegamento porta dove porterebbe senza JS.
*/

(function () {
  'use strict';

  var radice = document.querySelector('[data-carrello]');
  if (!radice || !window.fetch || !window.DOMParser) return;

  var sezione = radice.getAttribute('data-carrello-sezione') || '';
  var cambia = radice.getAttribute('data-url-cambia') || '/cart/change';
  var carrello = radice.getAttribute('data-url-carrello') || '/cart';
  var modello = radice.getAttribute('data-modello-conteggio') || '@n';
  var modelloTolto = radice.getAttribute('data-modello-tolto') || '';
  var occupato = false;

  function conteggio(numero) {
    var elementi = document.querySelectorAll('[data-conteggio-affido]');
    for (var i = 0; i < elementi.length; i++) {
      elementi[i].textContent = modello.replace('@n', String(numero));
    }
    document.dispatchEvent(new CustomEvent('cartcount', { detail: numero }));
    if (window.Daymonilia && typeof window.Daymonilia.misura === 'function') {
      window.Daymonilia.misura('affido_tolto');
    }
  }

  radice.addEventListener('click', function (evento) {
    var via = evento.target;
    while (via && via !== radice && !via.hasAttribute('data-carrello-togli')) via = via.parentNode;
    if (!via || via === radice || occupato) return;
    evento.preventDefault();
    occupato = true;
    via.setAttribute('aria-disabled', 'true');

    var linea = Number(via.getAttribute('data-linea'));
    var restanti = 0;

    fetch(cambia + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: linea, quantity: 0 })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('affido');
        return r.json();
      })
      .then(function (stato) {
        restanti = stato.item_count;
        conteggio(stato.item_count);
        return fetch(carrello + '?sections=' + sezione, { headers: { Accept: 'application/json' } });
      })
      .then(function (r) {
        if (!r.ok) throw new Error('sezione');
        return r.json();
      })
      .then(function (sezioni) {
        var nuovo = new DOMParser().parseFromString(sezioni[sezione] || '', 'text/html').querySelector('[data-carrello]');
        if (!nuovo) throw new Error('vuoto');
        radice.innerHTML = nuovo.innerHTML;
        /* Il fuoco non cade sul corpo pagina: resta sul Togli che ha preso quel posto, o sul titolo. */
        var prossimo = radice.querySelector('[data-carrello-togli][data-linea="' + linea + '"]') ||
          radice.querySelector('[data-carrello-togli]') ||
          radice.querySelector('.carrello__titolo');
        if (prossimo) prossimo.focus();
        var voce = radice.querySelector('[data-carrello-voce]');
        if (voce && modelloTolto) voce.textContent = modelloTolto.replace('@n', String(restanti));
        occupato = false;
      })
      .catch(function () {
        window.location.href = via.getAttribute('href');
      });
  });
})();
